// Mention format: @[type:id:name]
// type: u = user, s = story, c = character
export const MENTION_REGEX = /@\[(u|s|c):(\d+):([^\]]+)\]/g;

export type MentionType = 'u' | 's' | 'c';

export interface ParsedMention {
  type: MentionType;
  id: number;
  name: string;
  fullMatch: string;
  index: number;
}

export const extractMentions = (content: string): ParsedMention[] => {
  const mentions: ParsedMention[] = [];

  MENTION_REGEX.lastIndex = 0;

  let match;
  while ((match = MENTION_REGEX.exec(content)) !== null) {
    mentions.push({
      type: match[1] as MentionType,
      id: parseInt(match[2], 10),
      name: match[3],
      fullMatch: match[0],
      index: match.index,
    });
  }

  return mentions;
};

export const extractUniqueMentions = (content: string): ParsedMention[] => {
  const seen = new Set<string>();

  return extractMentions(content).filter((mention) => {
    const key = `${mention.type}:${mention.id}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export const getMentionPath = (mention: Pick<ParsedMention, 'type' | 'id'>) => {
  switch (mention.type) {
    case 'u':
      return `/users/${mention.id}`;
    case 's':
      return `/stories/${mention.id}`;
    case 'c':
      return `/play/characters/${mention.id}`;
  }
};

export const getDisplayText = (content: string): string => {
  return content.replace(MENTION_REGEX, '@$3');
};

export const hasMentions = (content: string): boolean => {
  MENTION_REGEX.lastIndex = 0;
  return MENTION_REGEX.test(content);
};

export const encodeMention = (
  type: 'user' | 'story' | 'character',
  id: number,
  name: string
): string => {
  const typeCode = type === 'user' ? 'u' : type === 'story' ? 's' : 'c';
  return `@[${typeCode}:${id}:${name}]`;
};
